import React from "react";
import { useTranslation } from "react-i18next";
import styled, { css } from "styled-components";
import { defaultCompare as naturalSort } from "logic/DefaultCompare";
import ShardRouting from "components/indices/ShardRouting";
const ShardRoutingWrap = styled.div(
  ({ theme }) => css`
    .shards {
      .shard {
        padding: 10px;
        margin: 5px;
        width: 50px;
        float: left;
        text-align: center;
      }

      .shard-started {
        background-color: ${theme.utils.colorLevel(theme.colors.variant.light.success, -2)};
      }

      .shard-relocating {
        background-color: ${theme.utils.colorLevel(theme.colors.variant.light.primary, -2)};
      }

      .shard-initializing {
        background-color: ${theme.utils.colorLevel(theme.colors.variant.light.warning, -5)};
      }

      .shard-unassigned {
        background-color: ${theme.utils.colorLevel(theme.colors.variant.light.default, -2)};
      }

      .shard-primary .id {
        font-weight: bold;
        margin-bottom: 3px;
        border-bottom: 1px solid ${theme.colors.gray[10]};
      }
    }

    .description {
      font-size: ${theme.fonts.size.small};
      margin-top: 2px;
      margin-left: 6px;
    }
  `
);
const ShardRoutingOverview = ({ indexName, routing }) => {
  const { t } = useTranslation("indexsets");
  return /* @__PURE__ */ React.createElement(ShardRoutingWrap, null, /* @__PURE__ */ React.createElement("h3", null, t("shards.routing_title")), /* @__PURE__ */ React.createElement("ul", { className: "shards" }, routing.sort((shard1, shard2) => naturalSort(shard1.id, shard2.id)).map((route) => /* @__PURE__ */ React.createElement(ShardRouting, { key: `${indexName}-shard-route-${route.node_id}-${route.id}`, route }))), /* @__PURE__ */ React.createElement("br", { style: { clear: "both" } }), /* @__PURE__ */ React.createElement("div", { className: "description" }, t("shards.routing_description")));
};
export default ShardRoutingOverview;
